<app-dialog
  [title]="'Map SKU to Product'"
  [description]="currentProduct?.Name"
  (action)="action($event)"
  (close)="close()"
  [actions]="actions"
>
<mat-dialog-content>
  <div class="container">
    <mat-slide-toggle *ngIf="!data.isCreateOrder" class="text-end" [formControl]="toggleActive" (change)="changeToggle($event)"><span class="toggle">Bundle Mapping</span></mat-slide-toggle>
    <app-item-typeahead *ngIf="!data.isCreateOrder && productInfo"
    [name]="productInfo?.name"
    [id]="productInfo?.id"
    [image]="productInfo?.image"
    [isVendorItem]="true"
     ></app-item-typeahead>
    <ng-container *ngIf="isActiveForm">
      <div>
        <div class="plan-shipment-sku plan-shipment-sku_item">
          <div class="plan-sku">
            <div class="plan-sku_form" [formGroup]="skuForm">
              <div class="input-container input-container--fullWidth">
                <div class="d-flex justify-content-between">
                  <label for="" class="input-container_label">SKU</label>
                </div>
                <input
                  type="text"
                  class="input-container_input"
                  formControlName="skuAutocomplete"
                  [matAutocomplete]="auto1"
                />
                <mat-autocomplete
                  #auto1="matAutocomplete"
                  [displayWith]="displayWith"
                  (optionSelected)="optionSelected($event.option.value)"
                >
                  <mat-option
                    *ngFor="let option of filteredOptions$ | async"
                    [value]="option"
                    class="mat-option-override"
                  >
                    <app-item-typeahead
                      [name]="option.title"
                      [sku]="option.sku"
                      [asin]="option.asin"
                      [account]="option.account"
                      [image]="option.imageUrl"
                    ></app-item-typeahead>
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="product-form" >
          <div
            class="product-form_form"
            *ngFor="let item of productsForm.controls; let i = index"
          >
            <div [formGroup]="item" class="product-form_item">
    
              <div class="input-container">
                <input
                  type="text"
                  placeholder="Pick one"
                  aria-label="Number"
                  class="input-container_input"
                  formControlName="product"
                  [matAutocomplete]="auto"
                  (click)="setScroll(i)"
                />
                <mat-autocomplete
                  #auto="matAutocomplete"
                  autoActiveFirstOption
                  [displayWith]="displayFn"
                >
                  <mat-option
                    *ngFor="let option of fitleredItemsOptions[i]"
                    [value]="option"
                    class="mat-option-override"
                  >
                    <app-item-typeahead
                      [name]="option.name"
                      [id]="option.id"
                      [image]="option.imageUrl"
                    ></app-item-typeahead>
                  </mat-option>
                </mat-autocomplete>
              </div>
    
              <div class="input-container">
                <input
                  type="number"
                  class="input-container_input"
                  formControlName="qty"
                  min="0"
                />
              </div>
    
              <div class="product-form_remove" (click)="removeProduct(i)">
                <i class="fal fa-times-circle"></i>
              </div>
            </div>
          </div>
    
          <div class="product-form_add">
            <app-button
              (click)="addProductToForm(1, undefined, false)"
              [buttonSize]="'action'"
            >
              <i class="fal fa-plus"></i> Add Product</app-button
            >
          </div>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActiveForm && !data.isCreateOrder">
      <div class="add-sku pt-0">
        <div class="add-sku_form" [formGroup]="skuMappingForm">
          <div class="input-container input-container--flex">
            <div class="d-flex justify-content-between">
              <label for="" class="input-container_label">Search SKUs</label>
            </div>
            <input id="skuMappingcomplete"
              type="text"
              class="input-container_input"
              formControlName="skuMappingcomplete"
              [matAutocomplete]="auto"
              (paste)="onPaste($event)"
              (click)="setScrollForSku()"
            />
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" (optionSelected)="onChange($event.option.value)">
              <mat-option
                *ngFor="let option of skuMappingfilteredOptions"
                [value]="option"
                class="mat-option-override">
                <app-item-typeahead
                        [name]="option.title"
                        [sku]="option.sku"
                        [asin]="option.asin"
                        [image]="option.imageUrl"
                        [condition]="option.condition"
                        [account]="option.account"
                ></app-item-typeahead>
              </mat-option>
            </mat-autocomplete>
          </div>
    
          <div class="input-container input-container--qty">
            <label for="" class="input-container_label">Quantity</label>
            <input
              type="number"
              class="input-container_input"
              [min]="0"
              formControlName="skuQty"
              id="qty"
              (keyup.enter)="verifyAndLoadSku()"
              (change)="changeQty($event)"
            />
            <span class="danger_color2 error-msg mt-2"
              *ngIf="((skuMappingForm.get('skuQty').touched ||
                skuMappingForm.get('skuQty').dirty) && skuMappingForm.get('skuQty').errors)">
            </span>
          </div>
    
          <div class="add-sku_button">
            <button class="button" (click)="verifyAndLoadSku()">
              Add SKU
            </button>
          </div>
        </div>
      </div>
        <div class="add-sku_list" *ngIf="selectedSKU?.length">
          <div class="add-sku_list-title">Selected SKUs</div>
          <app-shipment-sku
            [box]="true"
            [sku]="sku"
            [skuRemove]="true"
            [showMappedProduct]="true"
            (removeSkuEvent)="removeSku(sku)"
            *ngFor="let sku of selectedSKU"
          ></app-shipment-sku>
        </div>
    </ng-container>
  </div>
</mat-dialog-content>
</app-dialog>
